var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-content",attrs:{"id":"site-content"}},[_c('span',{staticClass:"site-content-loading"},[_vm._v("Loading...")]),_c('div',{staticClass:"content-area",attrs:{"id":"site-content-area"}},[_c('div',{staticClass:"container-fluid"},[_c('router-view',{key:_vm.$route.fullPath},[_vm._v("Loading...")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }